import { reactive, toRefs } from 'vue'

function getDefaultState () {
  return {
    active: false
  }
}

const state = reactive(getDefaultState())

function resetState () {
  Object.assign(state, getDefaultState())
}

export default toRefs(state)

export {
  resetState
}
